import { Component, EventEmitter, Output } from '@angular/core';
import { MenuItem } from 'src/app/models/shared/layout/layout.interface';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService, Base64Service, CurrencyService, MenuService, TokenService } from 'src/app/shared/services';
import { environment as env } from 'src/environments/environment';
import { WebTypeConstant } from 'src/app/shared/constants/common-constant';

interface Breadcrumb {
    label: string;
    url: string;
}

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
    constructor(
        private router: Router,
        private base64Service: Base64Service,
        private authService: AuthService,
        private menuService: MenuService,
        private tokenService: TokenService,
        private currencyService: CurrencyService
    ) { }

    // @Input() sidebarData!: Sidebar;
    @Output() breadcrumbChange = new EventEmitter<Breadcrumb[]>();

    filteredMenu: any[] = [];

    menuItems: MenuItem[] = [];
    activeRoute: string = '';
    openedMenu: any = null;
    webType: any = '';

    selectedCurrency: any = {};
    currencyCode: any = '';

    ngOnInit() {
        this.authService.getWebType().subscribe(webType => {
            this.webType = webType;
        });

        this.menuItems = this.menuService.getMenuList();

        this.selectedCurrency = this.currencyService.getCurrency();
        this.currencyCode = this.selectedCurrency?.currencyCode ?? '';

        this.activeRoute = this.tokenService.getSessionToken(env.TokenKeys.ActiveRoute) || this.getCleanRoutePath(this.router.url);

        this.expandActiveMenu(this.menuItems, this.activeRoute);

        // Listen for route changes
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.activeRoute = this.getCleanRoutePath(event.urlAfterRedirects);

                this.tokenService.setSessionToken(env.TokenKeys.ActiveRoute, this.activeRoute);

                // Deep copy current state
                const backupMenu = JSON.parse(JSON.stringify(this.menuItems));

                // this.deactivateAllMenus(this.menuItems);
                const found = this.expandActiveMenu(this.menuItems, this.activeRoute);

                // If not found, restore previous state
                if (!found) {
                    this.menuItems = backupMenu;
                }
            }
        });
    }

    getCleanRoutePath(url: string) {
        const urlTree = this.router.parseUrl(url);
        const currentRoute = '/' + urlTree.root.children['primary']?.segments.map(segment => segment.path).join('/') || '';

        return currentRoute;
    }

    closeOtherMenus(selectedItem: any, menuItems?: any[]) {
        if (menuItems) {
            menuItems.forEach((menuItem) => {
                if (menuItem !== selectedItem) {
                    menuItem.isOpen = false;
                    menuItem.isActive = false;
                }

                if (menuItem.children && menuItem.children.length > 0) {
                    this.closeOtherMenus(selectedItem, menuItem.children);
                }
            });
        }
    }

    toggleMenu(item: any, parent?: any[]) {
        if (!item.children?.length) {
            if (item.isActive === true) {
                this.closeSidebar();
                return;
            }
            else {
                // this.deactivateAllMenus(this.menuItems);
                item.isActive = true;
                this.closeSidebar();
                return;
            }
        }

        if (parent) {
            parent.forEach(menuItem => {
                if (menuItem !== item) {
                    menuItem.isOpen = false;
                    menuItem.isActive = false;
                    // this.deactivateAllMenus(menuItem.children);
                }
            });
        } else {
            this.menuItems.forEach(menuItem => {
                if (menuItem !== item) {
                    menuItem.isOpen = false;
                    menuItem.isActive = false;
                    // this.deactivateAllMenus(menuItem.children);
                }
            });
        }

        item.isOpen = !item.isOpen;
        item.isActive = item.isOpen;
    }

    deactivateAllMenus(menuItems?: any[]) {
        if (menuItems) {
            menuItems.forEach(menuItem => {
                menuItem.isOpen = false;
                menuItem.isActive = false;

                if (menuItem.children && menuItem.children.length > 0) {
                    this.deactivateAllMenus(menuItem.children);
                }
            });
        }
    }

    expandActiveMenu(menuList: any[], activeRoute: string): boolean {
        let found = false;

        for (const item of menuList) {
            // Recursively check children first
            const childFound = item.children && this.expandActiveMenu(item.children, activeRoute);

            let route = item.route;

            if (this.webType == WebTypeConstant.AGENTUNLIMITED || this.webType == WebTypeConstant.AGENTSTAFFUNLIMITED) {
                route = `/${this.currencyCode.toLowerCase()}${item.route}`;
            }   

            const isActive = route === activeRoute || this.isSubRoute(route, activeRoute);
            item.isActive = isActive;
            item.isOpen = isActive || childFound;

            found = found || isActive || childFound;
        }

        return found;
    }

    private isSubRoute(parentRoute: string, activeRoute: string): boolean {
        if (!activeRoute.startsWith(parentRoute)) return false;

        const relativePath = activeRoute.replace(parentRoute, "").split("/").filter(Boolean);
        if (relativePath.length !== 1) return false;

        const lastSegment = relativePath[0];
        return lastSegment === "new" || /^\d+$/.test(this.base64Service.decode(lastSegment));
    }

    closeSidebar() {
        if (window.innerWidth <= 768) {
            document.body.classList.remove('sidebar-open');
        }
    }

    getRouterLink(route: string) {
        if (this.webType == WebTypeConstant.AGENTUNLIMITED || this.webType == WebTypeConstant.AGENTSTAFFUNLIMITED) {


            return `/${this.currencyCode.toLowerCase()}/${route}`;
        } else {
            return route;
        }
    }
}
